<div class="block rounded-large border overflow-hidden white-bg mr-large-t">
  <form class="ps-medium" [formGroup]="loginForm" (ngSubmit)="onSubmit()" autocomplete="off">
    @if ((loading$ | async) === true) {
      <div class="align-center" data-testid="form-loading">
        <div class="ps-xxsmall-b grey-600-text font-body-1" aria-live="assertive">
          <fcom-loader [loaderType]="LoaderTheme.INLINE_TEXT"></fcom-loader>
          {{ 'actions.loading' | finLocalization }}
        </div>
        <fcom-button
          data-testid="cancel-retrieve"
          [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
          [text]="'actions.cancel' | finLocalization"
          (clickBtn)="cancelRetrieve()"
        ></fcom-button>
      </div>
    } @else {
      <div class="flex mobile-column">
        <fcom-text-input
          class="flex-1 flex--basis0 ms-large-b"
          data-testid="mmb-refund-form-input-recloc"
          [parentForm]="loginForm"
          [displayMargin]="false"
          [controlName]="'recLoc'"
          [required]="false"
          [translationPrefix]="'loginFields.recLoc'"
          [placeHolder]="'loginFields.recLoc.example'"
          [translationErrorPrefix]="'loginFields.recLoc.validationMessages'"
        ></fcom-text-input>

        <div class="ps-medium-r"></div>

        <fcom-text-input
          class="flex-1 flex--basis0 ms-large-b"
          data-testid="mmb-refund-form-input-lastname"
          [parentForm]="loginForm"
          [displayMargin]="false"
          [controlName]="'lastName'"
          [required]="false"
          [translationPrefix]="'loginFields.lastName'"
          [placeHolder]="'loginFields.lastName.example'"
          [translationErrorPrefix]="'loginFields.lastName.validationMessages'"
        ></fcom-text-input>
      </div>
      <div class="flex content-container" data-testid="mmb-refund-form-content-container">
        <div class="flex flex-1 flex--basis0 flex--column">
          <div class="inline-block">
            <fcom-link
              data-testid="info-link-recloc"
              [href]="'mmbRefundForm.links.recloceticket.link.url' | finLocalization"
              [openInNewTab]="true"
            >
              {{ 'mmbRefundForm.links.recloceticket.text' | finLocalization }}
            </fcom-link>
          </div>
          <div class="inline-block mr-small-t">
            <fcom-link
              data-testid="info-link-refund"
              [href]="'mmbRefundForm.links.refund.link.url' | finLocalization"
              [openInNewTab]="true"
            >
              {{ 'mmbRefundForm.links.refund.text' | finLocalization }}
            </fcom-link>
          </div>
        </div>

        <fcom-button
          class="button-container"
          data-testid="mmb-refund-form-submit-button"
          [type]="ButtonType.SUBMIT"
          [size]="ButtonSize.LARGE"
          [mode]="ButtonMode.FILL_MOBILE"
          [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
          [text]="'mmbRefundForm.submitText' | finLocalization"
          [attr.aria-label]="'mmbRefundForm.submitAria' | finLocalization"
          (mousedown)="$event.preventDefault()"
          [icon]="{
            name: SvgLibraryIcon.ARROW_RIGHT,
            position: IconPosition.RIGHT,
          }"
        >
        </fcom-button>
      </div>
    }

    @if (error$ | async; as error) {
      <fcom-notification
        data-testid="mmb-refund-form-error"
        [theme]="error.theme"
        [layout]="NotificationLayout.BLOCK"
        [isClosable]="true"
        class="ms-large-t block"
        aria-live="polite"
        (closeClick)="error$.next(null)"
      >
        {{ error.message | finLocalization }}
      </fcom-notification>
    }
  </form>
</div>
